/* eslint-disable */
'use strict';

var P = P || {};

P.Notifier = {
  stack_bar_bottom: { dir1: 'right', dir2: 'up', push: 'top', firstpos1: 25, firstpos2: 25 },
  _display: function(type, message) {
    if ($(window).width() < 480) {
      this.stack_bar_bottom.firstpos1 = 0;
      this.stack_bar_bottom.firstpos2 = 0;
    }

    new PNotify({
      type: type,
      text: message,
      addclass: 'stack-bottomleft',
      stack: this.stack_bar_bottom,
      mobile: {
        styling: true,
        swipe_dismiss: true,
      },
    });
  },

  notice: function(message) {
    this._display('notice', message);
  },
  info: function(message) {
    this._display('info', message);
  },
  success: function(message) {
    this._display('success', message);
  },
  error: function(message) {
    this._display('error', message);
  },
  invoke: function() {
    // invoke messages from the global scope
    var self = this;
    if (typeof messages != 'undefined') {
      for (var i in messages) {
        var k = messages[i];
        if (k.type == 'notice') self._display('notice', k.message);
        else if (k.type == 'info') self._display('success', k.message);
        else if (k.type == 'error') self._display('error', k.message);
        else if (k.type == 'success') self._display('success', k.message);
      }
    }
  },
};
P.Notifier.invoke();

P.alert = function(message) {
  var dialog = bootbox.alert({ className: 'form-modal', show: false, message: message });
  dialog.modal('show');
  return dialog;
};

P.ModalConfirm = function(options) {
  this.options = {
    triggerElement: null,
    onConfirm: this.onConfirm,
    onCancel: this.onCancel,
    onSuccessSubmit: null,
    path: null,
    title: null,
    message: null,
  };
  this.options = $.extend(this.options, options);
  this.init();
};

function isFunction(functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

P.ModalConfirm.prototype = {
  init: function() {
    var self = this;
    if (this.options.triggerElement.length === 1) {
      this.options.triggerElement.on('click', function(e) {
        var $el = $(this);
        if (!$el.is('input[type=checkbox]')) e.preventDefault();
        self._clicked = $el;
        self.start.apply(self);
      });
    } else if (this.options.triggerElement.length > 1) {
      this.options.triggerElement.each(function() {
        var opt = self.options;
        opt.triggerElement = $(this);
        new P.ModalConfirm(opt);
      });
    }
  },
  addListenTo: function(el) {
    var self = this;
    el.each(function() {
      var opt = self.options;
      opt.triggerElement = $(this);
      new P.ModalConfirm(opt);
    });
  },
  start: function() {
    // submit on click of footer Button in Modal
    if (isFunction(this.options.message)) {
      this.options.realMsg = this.options.message.apply(this);
    } else {
      this.options.realMsg = this.options.message;
    }

    var modal = this.create_modal();
    modal.find('.modal-footer > button.btn-primary').prependTo(modal.find('.modal-footer'));
    modal.find('.modal-footer > button.btn-primary').after("<div id='js-status-form' class='help-text'></div>");
    modal.modal('show');
  },
  path: function() {
    if (typeof this.options.path === 'function') {
      return this.options.path.apply(this);
    }
    return this.options.path;
  },
  create_modal: function() {
    var self = this;
    this._modal = bootbox.confirm({
      title: this.options.title,
      message: this.options.realMsg,
      className: 'form-modal',
      buttons: $.extend(
        {
          confirm: {
            label: gettext('REMOVE'),
            className: 'btn-primary btn btn-lg pull-left',
          },
          cancel: {
            label: gettext('Cancel'),
            className: 'btn-link btn-lg pull-right',
          },
        },
        this.options.buttons,
      ),
      callback: function(res) {
        if (res) self.options.onConfirm.apply(self, []);
        else self.options.onCancel.apply(self, []);
      },
    });
    return this._modal;
  },
  onConfirm: function() {
    var self = this;

    $.post(this.path())
      .done(function(data, textStatus, jqXHR) {
        P.Notifier.success(data.success);
        if (jqXHR.getResponseHeader('REQUIRES_AUTH') === '1') {
          window.location = '/';
        } else {
          if (self.options.onSuccessSubmit) self.options.onSuccessSubmit.apply(self);
        }
      })
      .fail(function(data) {
        try {
          P.Notifier.error(data.responseJSON.error);
        } catch (err) {
          P.Notifier.error('Server Communication Error');
        }
        self.options.onCancel.apply(self, []);
      });
  },
  onCancel: function() {},
};

P.ModalForm = function(options) {
  this.options = {
    onsubmit: this.onsubmit,
    onerror: this.onerror,
    fixData: null,
    onClose: null,
    triggerElement: null,
    path: null,
    formContainer: null,
    onSuccessSubmit: null,
    onModalActive: null,
    onFormLoaded: null,
    validatorConfig: null,
    initial: false,
  };
  this.options = $.extend(this.options, options);
  this.init();

  if (this.options.initial) {
    var self = this;
    $(document).ready(function() {
      setTimeout(function() {
        self.options.triggerElement.trigger('click');
      }, 500);
    });
  }
};

P.ModalForm.prototype = {
  init: function() {
    var self = this;
    if (this.options.triggerElement.length == 1) {
      this.options.triggerElement.on('click', function(e) {
        e.preventDefault();
        self._clicked = $(this);
        self.start.apply(self);
      });
    } else if (this.options.triggerElement.length > 1) {
      this.options.triggerElement.each(function() {
        var opt = self.options;
        opt.triggerElement = $(this);
        new P.ModalForm(opt);
      });
    }
  },
  start: function() {
    // submit on click of footer Button in Modal
    var self = this;

    var modal = this.create_modal();

    modal.find('.modal-footer > button.btn-primary').after("<div id='js-status-form' class='help-text'></div>");

    if (this.options.onModalActive) {
      modal
        .on('show.bs.modal', function() {
          self.options.onModalActive.apply(self);
        })
        .on('shown.bs.modal', function() {
          $('.bootbox.modal.in').scrollTop(0);
        });
    }

    modal.modal('show');

    this.make_validation();
  },
  make_validation: function() {
    if (this.options.formContainer && this.options.validatorConfig) {
      this.options.formContainer.validate(this.options.validatorConfig);
    }
  },
  create_modal: function() {
    var self = this;
    var submitFunc = function(e) {
      return self.options.onsubmit.apply(self, [e]);
    };
    self._modal = bootbox.dialog({
      title: self.options.title,
      closeButton: true,
      className: 'form-modal',
      message: self.container(),
      buttons: $.extend(
        true,
        {
          success: {
            label: gettext('SAVE'),
            className: 'btn-lg btn-primary',
            callback: submitFunc,
          },
          close: {
            label: gettext('Close'),
            className: 'btn-lg btn-link pull-right close-btn',
            callback: () => {
              if (this.options.onClose) return this.options.onClose();
            },
          },
        },
        this.options.buttons,
      ),
      show: false,
      animate: false,
      onEscape: () => {
        if (this.options.onClose) return this.options.onClose();
      },
    });

    if (typeof this.options.subTitle !== 'undefined') {
      self._modal.find('h4').wrap("<div class=''></div>");
      self._modal.find('.modal-header').append("<h5 class='modal-microcopy'>" + this.options.subTitle + '</h5>');
    }

    self._modal.find('form').append('<input type="submit" style="display:none;">');
    self._modal
      .find('form')
      .submit(submitFunc)
      .find('input')
      .keydown(function(e) {
        if (e.keyCode == 13) {
          $(this)
            .parents('form')
            .submit();
          return false;
        }
      });

    self._modal.css({ display: 'block' });
    return self._modal;
  },
  setModalMessage: function(type, msg) {
    var className = 'text-info';
    var $msg = this._modal.find('#js-status-form');
    if (type == 'success') className = 'text-success';
    else if (type == 'danger') className = 'text-danger';

    $msg.attr('class', 'help-text');
    $msg.addClass(className).text(msg);
  },
  getContainer: function() {
    var self = this;
    var f = $(
      '<div class="u-align-center"><div class="o-spinner" ></div><div class="o-loading-title">' +
        gettext('Loading data...') +
        '</div></div>',
    );
    $.get(this.path())
      .done(function(data) {
        var $data = $(data);
        self.options.formContainer = $data;
        self.make_validation();
        f.replaceWith($data);

        if (self.options.onFormLoaded) self.options.onFormLoaded.apply(self);
      })
      .fail(function() {
        P.Notifier.error(gettext('Server Communication Error'));
        self._modal.modal('hide');
      });
    return f;
  },
  container: function() {
    if (!this.options.formContainer) {
      return this.getContainer();
    }
    return this.options.formContainer;
  },
  path: function() {
    if (typeof this.options.path === 'function') {
      return this.options.path.apply(this);
    }
    return this.options.path;
  },
  onsubmit: function(e) {
    // submit the form to server with ajax
    //$.ajax
    e.preventDefault();
    var self = this;

    if (this.options.formContainer.is('form')) var form = this.options.formContainer;
    else var form = this.options.formContainer.find('form');

    if (this.options.validatorConfig && !form.valid()) {
      return false;
    }
    this.setModalMessage('info', gettext('Saving data ...'));

    let formData = form.serialize();
    if (self.options.fixData) {
      formData = self.options.fixData(formData);
    }

    $.post(this.path(), formData)
      .done(function(data) {
        if (data != '') {
          P.Notifier.success(data.success);
        }

        self.setModalMessage('success', gettext('Data Saved Successfully'));

        if (self.options.onSuccessSubmit) {
          self.options.onSuccessSubmit.apply(self, [form, data]);
        }

        self._modal.modal('hide');
      })
      .fail(function(qXHR) {
        var response = qXHR.responseJSON;

        var errors = {};
        self.setModalMessage('danger', gettext('Error Validating'));
        $.each(response, function(key, error_list) {
          $.each(error_list, function(index, field_error) {
            if (key == '__all__') {
              self.setModalMessage('danger', gettext(field_error));
            } else {
              errors[key] = field_error;
            }
          });
        });

        form.validate().showErrors(errors);

        if (self.options.dialog_callback) {
          self.options.dialog_callback(dialog);
        }
      })
      .always(function() {});

    return false;
  },
  onerror: function() {},
};
P.rh_state_field = function(country_code, state) {
  var val = country_code.find('option:selected').val();
  state.prop('disabled', !(val == 'US' || val == 'CA'));

  country_code.on('change', function() {
    var val = country_code.find('option:selected').val();
    if (val == 'US' || val == 'CA') {
      state.prop('disabled', false);
      state.valid();
    } else {
      state.parents('.form-group').removeClass('has-error');
      state.val('').prop('disabled', true);
      state.valid();
    }
  });
};

// Django uses Associated Press style.
// https://docs.djangoproject.com/en/1.5/ref/templates/builtins/#date
// http://apstylebook.blogspot.co.il/2009/06/months.html
P.MONTH_NAMES = 'Jan. Feb. March April May June July Aug. Sept. Oct. Nov. Dec.'.split(' ');

P.month_name = function(month) {
  return P.MONTH_NAMES[month];
};

P.organizationDetailsForm = null;
P.addNewCardForm = null;

module.exports = P;
